<template>
  <div>
    <el-header>{{ $t('common.finish') }}</el-header>
    <el-form-item :label="$t('interiorDecorator.type')">
      <el-radio-group v-model="embrace.finishCode" @change="handleEmbraceChange">
        <el-radio :label="embraceFinishes.Banana.Code">{{ $t(embraceFinishes.Banana.TranslationString) }}</el-radio>
        <el-radio :label="embraceFinishes.Straight.Code">{{ $t(embraceFinishes.Straight.TranslationString) }}</el-radio>
      </el-radio-group>
    </el-form-item>

    <el-form-item :label="$t('interiorDecorator.width')">
      <input-number v-model="embrace.widthInCm" :precision="1" :step="0.1" :min="10" />
    </el-form-item>
  </div>
</template>

<script>
import InputNumber from '@/components/DSE/InputNumber';
import { EmbraceFinishes } from '../constants';
export default {
  components: {
    InputNumber
  },
  props: {
    embrace: {
      type: Object
    },
    orderLineDraft: {
      type: Object
    }
  },
  data() {
    return {
      embraceFinishes: EmbraceFinishes
    };
  },
  methods: {
    handleEmbraceChange(newValue) {
      let requiredFabric;
      switch (newValue) {
        case EmbraceFinishes.Banana.Code:
          requiredFabric = EmbraceFinishes.Banana.HeightInCm;
          break;
        case EmbraceFinishes.Straight.Code:
          requiredFabric = EmbraceFinishes.Straight.HeightInCm;
          break;
        default:
          requiredFabric = '';
          break;
      }
      this.orderLineDraft.requiredFabricInCm = requiredFabric;
    }
  }
};
</script>
